import { IHelpContextRepository } from "@/core/repositories/helpContext";

export class SetIsFirstTimeDeductionPageUseCase {
  constructor(private readonly helpContextRepository: IHelpContextRepository) {}

  async execute(isFirstTimeSearch?: boolean): Promise<void> {
    await this.helpContextRepository.setIsFirstDeductionPage(isFirstTimeSearch ?? false);
  }
}
